import { Pipe, PipeTransform } from '@angular/core';

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/**
 * "2026-07-21" → "21 Jul 2026", read as a calendar date. The `date` pipe
 * parses a date-only string as local midnight and then formats in +09:30, so
 * anywhere east of Darwin it shows the day before.
 */
@Pipe({ name: 'calendarDay', standalone: false })
export class CalendarDayPipe implements PipeTransform {
    transform(ymd: string | null | undefined, withYear = true): string {
        const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(ymd ?? '');
        if (!m) {
            return ymd ?? '';
        }
        return `${Number(m[3])} ${MONTHS[Number(m[2]) - 1]}${withYear ? ` ${m[1]}` : ''}`;
    }
}
